import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastController, LoadingController, AlertController } from 'ionic-angular';
import { Observable } from 'rxjs';

@Injectable()
export class UtilityProvider {

  loader: any = null;
  toast: any; 

  constructor(public alertCtrl: AlertController, public loadingCtrl: LoadingController, public toastCtrl: ToastController, public http: HttpClient) {
  }
  
  //loading
  private showLoadingHandler(){
    if (this.loader == null) {
        this.loader = this.loadingCtrl.create();
        this.loader.present();
    }
  }

  private hideLoadingHandler(){
      if (this.loader != null) {
          this.loader.dismiss();
          this.loader = null;
      }
  }

  showLoader(){
      this.showLoadingHandler();
  }

  hideLoader(){
      this.hideLoadingHandler();
  }

  //toast
  private showToastHandler(text){
    this.toast = this.toastCtrl.create({
      message: text,
      duration: 12000,
      position: 'top',
      showCloseButton: true,
      closeButtonText: 'X'
     })
     this.toast.present()
  }

  showToast(text){
    this.showToastHandler(text)
  }

  //alert 
  private showAlertHandler(text){
    let alert = this.alertCtrl.create({
      title: text,
      buttons: ['Dismiss']
    });
    alert.present();
  }

  showAlert(text){
    this.showAlertHandler(text)
  }

  getWarningMessage() : Observable<any> {
    return this.http.get(window.location.origin + window.location.pathname + 'assets/message.json')
  }

}



// WEBPACK FOOTER //
// ./src/providers/utility/utility.ts